import { render } from "./NoInternet.vue?vue&type=template&id=8e6dc1b0&ts=true"
import script from "./NoInternet.vue?vue&type=script&lang=ts"
export * from "./NoInternet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__